// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity-mini[data-v-8d896d06]{grid-template-columns:50px 350px 1fr!important}", ""]);
// Exports
module.exports = exports;
